import { shadowLight } from 'app/colors';
import styled from '@emotion/styled';
import TableScrollContainer from 'components/Tables/ScrollContainer';
import { layers } from 'app/spacing';
import css from '@emotion/css';

export const ConfigurationArea = styled.div`
  display: flex;
  width: 100%;
  column-gap: 20px;
  ${({ noTopMargin }) =>
    noTopMargin
      ? css`
          margin-top: 0;
        `
      : css`
          margin-top: 20px;
        `}
  height: 0;
  min-height: 250px;
  flex-grow: 1;
`;

export const ConfigurationPanel = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  border: 1px solid var(--color-border-medium);
  ${({ highlighted }) =>
    highlighted
      ? css`
          border: 1px dashed var(--color-button-secondary-default);
        `
      : ''}
  border-radius: 4px;
  background: var(--color-background-white);
  overflow: hidden;
  position: relative;
`;

export const ConfigurationPanelWrapper = styled.div`
  width: calc(50% - 10px);
  height: 100%;
  position: relative;
`;

export const ConfigurationPanelHeader = styled.div`
  padding: ${({ grow }) =>
    grow ? '22px 20px 22px 20px' : '11px 20px 11px 20px'};
  border-bottom: 1px solid var(--color-border-medium);
  display: flex;
  align-items: center;
  ${({ scrolled }) => (scrolled ? shadowLight : '')}
  z-index: ${({ zIndex }) =>
    zIndex !== undefined ? zIndex : layers.content(9, 9)};
`;

export const ColumnSearchContainer = styled.div`
  margin-left: auto;
`;

export const ConfigurationPanelBody = styled(TableScrollContainer)`
  flex-grow: 1;
  width: 100%;
  height: 0;
  overflow-y: auto;
  ${({ minHeight }) => (minHeight ? 'overflow-y: hidden' : '')}
`;
